import { FC, useCallback, useEffect } from 'react';

import { Dialog, useDialog } from 'components';
import { useResponse } from 'contexts/response';

import { useNewTransaction } from '..';
import { TransactionStatus } from '../new-transaction.context';

const TransactionSuccessDialog: FC = () => {
  const { closeDialog, openDialog, ref } = useDialog();
  const { status, setStatus } = useNewTransaction();
  const { success, setSuccess } = useResponse();

  useEffect(() => {
    if (status === TransactionStatus.DRAFT || status === TransactionStatus.TRANSACTION) {
      if (!ref.current?.open) openDialog();
    } else {
      if (ref.current?.open) closeDialog();
    }
  }, [ref, status, closeDialog, openDialog]);

  const handleCloseDialog = useCallback(() => {
    closeDialog();
    setStatus(undefined);
    setSuccess('');
  }, [closeDialog, setStatus, setSuccess]);

  return (
    <Dialog closeDialog={handleCloseDialog} ref={ref} data-cy="success-dialog">
      <div id="success-dialog" className="d-flex flex-column g-3">
        <h3 className="text-info-dark font-weight-medium">Save Success</h3>
        <p className="text-info-main">{success}</p>
        <div className="grid-3 mt-3 justify-items-end">
          <button className="btn-primary col-start-3" type="button" onClick={handleCloseDialog}>
            close
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default TransactionSuccessDialog;
